//Library
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import QS from 'query-string';
//redux
import { connect } from 'react-redux';
import { getTsrInfo } from '../../action/anueInfoAction';
//Component
import StepHome from './StepHome';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

class TSR extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 0
        }
    }

    componentWillMount() {
        if (this.props.isLogin === "Y") {
            this.initData();
        } else {
            const parsed = QS.parse(this.props.location.search.toLowerCase());
            if (parsed.sid !== undefined && parsed.fundid !== undefined) {
                this.props.history.push({ pathname: "/login", search: this.props.location.search + "&to=TSR" });
            } else {
                this.props.history.push("/index");
            }

        }
    }

    initData() {
        const parsed = QS.parse(this.props.location.search.toLowerCase());
        this.props.getTsrInfo(parsed.fundid, parsed.sid);
    }

    nextStep() {
        let nextStep = this.state.step + 1;
        this.setState({ step: nextStep }, () => {
            this.updateStepView(nextStep);
        });
    }

    prevStep() {
        let prevStep = this.state.step - 1;
        this.setState({ step: prevStep }, () => {
            this.updateStepView(prevStep);
        });
    }

    updateStepView(Step) {
        document.documentElement.scrollTop = 0;
        if (Step >= 1 && Step <= 3) {
            for (let i = 0; i < 3; i++) {
                if (Step > i)
                    document.getElementById("subTab").children[i].children[0].setAttribute("class", "nav-link tab2 M02 active");
                else
                    document.getElementById("subTab").children[i].children[0].setAttribute("class", "nav-link tab2 M02");
            }
        }
    }

    render() {
        return <div>
            <section>
                <div className="bannerblock">
                    <div className="bannercontent">
                        <a href="https://www.anuefund.com/EC/goodday/" target="_blank" rel="noopener noreferrer">
                        </a>
                    </div>
                </div>
            </section>
            {
                this.state.step === 0 ?
                    <StepHome nextStep={() => { this.nextStep() }} /> : <section id="choose" className="bgblack">
                        <div className="sectionblock" style={{ maxWidth: "900px", padding: "10px 5% 40px 5%" }}>
                            <ul className="nav nav-tabs anueSubTabs" id="subTab" >
                                <li className="nav-item" id="M01" style={{ flex: "1 1 30%" }}>
                                    <span className="nav-link tab2" id="subTab00_tab" >
                                        <div className="combinationName">
                                            <div className="tag" style={{ color: "white" }}>選擇基金</div>
                                        </div>
                                    </span>
                                </li>
                                <li className="nav-item" id="M02" style={{ flex: "1 1 30%" }}>
                                    <span className="nav-link tab2" id="subTab00_tab" >
                                        <div className="combinationName">
                                            <div className="tag" style={{ color: "white" }}>確認交易</div>
                                        </div>
                                    </span>
                                </li>
                                <li className="nav-item" id="M03" style={{ flex: "1 1 30%" }}>
                                    <span className="nav-link tab2" id="subTab00_tab" >
                                        <div className="combinationName">
                                            <div className="tag" style={{ color: "white" }}>確認完成</div>
                                        </div>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        {
                            this.state.step === 1 ?
                                <Step1 nextStep={() => { this.nextStep() }} /> :
                                this.state.step === 2 ?
                                    <Step2 nextStep={() => { this.nextStep() }} prevStep={() => { this.prevStep() }} /> :
                                    this.state.step === 3 ?
                                        <Step3 nextStep={() => { this.nextStep() }} prevStep={() => { this.prevStep() }} /> : ""
                        }
                    </section>
            }



        </div>
    }
}

function mapStateToProps(state) {
    return {
        isLogin: state.anueInfoState.isLogin,
        TSRDataInfo: state.anueInfoState.TSRDataInfo,
    };
}
export default connect(mapStateToProps, { getTsrInfo })(withRouter(TSR));